module.exports = __webpack_public_path__ + "media/images/tiedye/details-0768967767add0bf467e0c808b44164b.png";